import React from 'react';

import borderLeft from '../../static/border-tip-left.png';
import borderRight from '../../static/border-tip-right.png';
import './index.sass';

export default function HomeDeclar({ ...props }) {
  return (
    <div className='home-declaration-holder'>
      <div className='left-logo'>{'年轻饮料\n果子熟了'}</div>
      <div className='info-box'>
        <div className='border-tip text-right'>
          <img src={borderRight} alt='' className='border-tip-right' />
        </div>
        <div className='title-tip'>GUOZI CO.</div>
        <div className='title'>{'NATURAL FOOD \nMADE IN CHINA'}</div>
        <div className='motto'>做年轻人喜欢的饮料</div>
        <div className='content'>
          {
            '果子熟了，菓子熟了（南京）食品有限公司旗下的新锐饮料品牌，致力于成为最懂年轻人的饮料公司，让世界见证中国年轻力量。'
          }
        </div>
        <div className='border-tip'>
          {/* <img src={borderLeft} alt='' className='border-tip-left' /> */}
          {
            "GUOZI CO., an emerging beverage brand under Guozishule (Nanjing) Food Co., Ltd..Committed to becoming the most youth-empathic beverage enterprise, it dedicates itself to showcasing the vibrant energy of China's new generation to the global community."
          }
        </div>
      </div>
    </div>
  );
}
